import { render, staticRenderFns } from "./SolePropK.vue?vue&type=template&id=642c238c&scoped=true"
import script from "./SolePropK.vue?vue&type=script&lang=js"
export * from "./SolePropK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c238c",
  null
  
)

export default component.exports